export default __webpack_public_path__ + "864676f4a4b2d9be6a7f0e3172c58441.png";